import {
  Button, Image, Modal, Pagination, Space, Table,
} from 'antd';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import translations from '../../../hooks/translation/translations.json';
import useTranslation from '../../../hooks/translation/useTranslation';

function Banners() {
  const { trans } = useTranslation();
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const columns = [
    {
      title: trans('title'),
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: trans('banner_image'),
      dataIndex: 'banner_image',
      key: 'banner_image',
    },
    {
      title: trans('edit'),
      dataIndex: 'edit',
      key: 'edit',
    },
    {
      title: trans('delete'),
      dataIndex: 'delete',
      key: 'delete',
    },
  ];

  const fetchData = () => {
    axios.get('/api/admin/banners', { params: { page } }).then((res) => {
      if (res.data?.status === 'success') {
        setData(res?.data?.data);
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const handleDelete = (id) => {
    axios.delete(`/api/admin/banners/${id}`).then((res) => {
      if (res.data?.status === 'success') {
        fetchData();
      }
    });
  };

  const checkIfDelete = (id) => {
    Modal.confirm({
      title: translations.ka.delete_banner,
      content: translations.ka.do_you_want_to_delete,
      okText: translations.ka.yes,
      onOk: () => handleDelete(id),
      cancelText: translations.ka.no,
    });
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" onClick={() => navigate('/admin/banners/add')}>{trans('add_banner')}</Button>
      <div style={{ overflowX: 'auto' }}>
        <Table
          pagination={false}
          dataSource={data?.data?.map((banner) => ({
            key: banner.id,
            title: banner?.title_ka || banner?.title_en || banner?.title_ru,
            banner_image: <Image src={`/${banner?.banner_image_path_ka || banner?.banner_image_path_en || banner?.banner_image_path_ru}`} width={150} height={150} style={{ objectFit: 'contain' }} alt={banner?.title_ka || banner?.title_en || banner?.title_ru} />,
            edit: <Button onClick={() => navigate(`/admin/banners/${banner?.id}/edit`)}>{trans('edit')}</Button>,
            delete: (
              <Button
                type="danger"
                onClick={() => checkIfDelete(banner?.id)}
              >
                {trans('delete')}
              </Button>
            ),
          }))}
          columns={columns}
        />
      </div>
      {data?.data
      && (
      <Pagination
        pageSize={data?.meta?.itemsPerPage}
        total={data?.meta?.totalItems}
        current={page}
        onChange={(e) => setPage(e)}
      />
      )}
    </Space>
  );
}

export default Banners;
